__turbopack_context__.v({
  "card": "ForWho-module__CsFfsG__card",
  "cardAnswer": "ForWho-module__CsFfsG__cardAnswer",
  "cardHeader": "ForWho-module__CsFfsG__cardHeader",
  "cardIcon": "ForWho-module__CsFfsG__cardIcon",
  "cardMark": "ForWho-module__CsFfsG__cardMark",
  "cardText": "ForWho-module__CsFfsG__cardText",
  "cardTitle": "ForWho-module__CsFfsG__cardTitle",
  "container": "ForWho-module__CsFfsG__container",
  "grid": "ForWho-module__CsFfsG__grid",
  "titleLine": "ForWho-module__CsFfsG__titleLine",
});
